<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center no-padding-bottom">
            <span class="mask bg-gradient-danger opacity-8"></span>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <br><br><br>
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">

                                <div class="col-8">
                                    <h3 class="mb-0 text-uppercase">{{ this.$route.name }}</h3>
                                    <br>
                                    <span class="text-danger" v-if="policy && policy.title && showPolicy">
                                        {{ policy.title }}
                                    </span>
                                </div>
                                <div class="col-4 text-right">
                                    <router-link
                                        to="/register"
                                        class="btn btn-sm btn-danger"
                                    >
                                        <i class="fa fa-arrow-left"></i>
                                        Go Back
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="! isLoadingBlade && showPolicy">
                            <div class="col-lg-12"
                                v-html="policy.content"
                                v-if="policy"
                            ></div>

                            <div class="col-lg-12">
                                <hr>
                                <router-link
                                    to="/register"
                                    class="btn btn-danger text-white"
                                    :disabled="isLoadingBlade"
                                >
                                    <i class="fa fa-times"></i>
                                    I Disagree
                                </router-link>

                                <base-button
                                    type="success"
                                    class="right"
                                    :disabled="isLoadingBlade"
                                    @click="hidePolicyPage(false)"
                                >
                                    <i class="fa fa-check"></i>
                                    I Agree
                                </base-button>
                            </div>
                        </div>

                        <div class="row" v-if="isLoadingBlade">
                            <div class="col-lg-12">
                                <div class="d-flex justify-content-center">
                                    <img :src="loadingBladeUrl" />
                                </div>
                            </div>
                        </div>

                        <div v-if="! showPolicy && ! showTempPayPage && ! showTempRegPage && ! showTempRenewPage">
                            <div class="row" v-if='! showErrorStatus && ! isLoadingBlade'>
                                <div class="col-sm-12 text-center text-uppercase">
                                    <h2 class="text-danger">
                                        I am registering as a Temporary Doctor for the FIrst time
                                    </h2>
                                </div>
                                <div class="col-sm-6 text-center borderLine">
                                    <br>
                                    <h4 class="text-uppercase height-50">
                                       I have not paid the Account Creation Fee and want to pay now
                                    </h4>
                                    <br>
                                    <base-button
                                        type="primary"
                                        class="btn btn-sm"
                                        :disabled="isLoadingBlade"
                                        @click="showTempPage(true, 'pay')"
                                    >
                                        Click &amp; Continue
                                        <i class="fa fa-arrow-right"></i>
                                    </base-button>
                                    <br><br><br>
                                </div>

                                <div class="col-sm-6 text-center borderLine">
                                    <br>
                                    <h4 class="text-uppercase height-50">
                                        I have paid the Account Creation Fee and want to continue registration /
                                        check my Account Creation status
                                    </h4>
                                    <br>
                                    <base-button
                                        type="success"
                                        class="btn btn-sm"
                                        :disabled="isLoadingBlade"
                                        @click="showTempPage(true, 'reg')"
                                    >
                                        Click &amp; Continue
                                        <i class="fa fa-arrow-right"></i>
                                    </base-button>
                                    <br><br><br>
                                </div>
                                <div class="col-sm-12 text-center text-uppercase">
                                    <hr>
                                    <h2 class="text-danger">
                                        I am an existing Temporary Doctor, I just want to renew my license
                                    </h2>
                                </div>
                                <div class="col-sm-3"></div>
                                <div class="col-sm-6 text-center borderLine">
                                    <br>
                                    <h4 class="text-uppercase height-50">
                                        I want to renew my license only
                                    </h4>
                                    <br>
                                    <base-button
                                        type="info"
                                        class="btn btn-sm"
                                        :disabled="isLoadingBlade"
                                        @click="showTempPage(true, 'renew')"
                                    >
                                        Click &amp; Continue
                                        <i class="fa fa-arrow-right"></i>
                                    </base-button>
                                    <br><br><br>
                                </div>
                                <br><br><br><br><br><br><br><br><br>
                            </div>
                        </div>

                        <!-- The temporary verification payment page included here -->
                        <TempVerifyPayPage
                            :hidePolicyPage="hidePolicyPage"
                            v-if="showTempPayPage"
                        />

                        <!-- The temporary registration page included here -->
                        <TempRegistrationPage
                            :hidePolicyPage="hidePolicyPage"
                            v-if="showTempRegPage"
                        />

                        <!-- The temporary renew license page included here -->
                        <TempRenewPage
                            :showTempPage="showTempPage"
                            v-if="showTempRenewPage"
                        />


                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import TempVerifyPayPage from './TempDoctorRegister/TempVerifyPayPage';
    import TempRegistrationPage from './TempDoctorRegister/TempRegistrationPage';
    import TempRenewPage from './TempDoctorRegister/TempRenewPage.vue';

    export default {
        name: 'TempDoctorRegister',
        components: {
            TempVerifyPayPage,
            TempRegistrationPage,
            TempRenewPage
        },
        data() {
            return {
                isLoadingBlade: true,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                showPolicy: true,
                policy: null,
                showTempPayPage: false,
                showTempRegPage: false,
                showTempRenewPage: false
            }
        },
        computed: {
            ...mapGetters(['loadingBladeUrl']),
        },
        methods: {
            ...mapActions(['getSiteParameter']),
            getParameter() {// get Parameter
                let name = 'temporary-policy';
                this.getSiteParameter({'name': name}).then((res) => {
                    this.isLoadingBlade = false;
                    if(res) {
                        this.policy = res;
                    } else {
                        this.showErrorStatus = true;
                        this.isLoadingBlade = false;
                        this.errorMsg = "Network Failure!, kindly reload the page...";
                        this.errorType = 'danger';
                    }
                }).
                catch(() => {
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Network Failure!, kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            hidePolicyPage(value) {
                this.showTempPayPage = false;
                this.showTempRegPage = false;
                return this.showPolicy = value;
            },
            showTempPage(value, type) {
                if(type == 'pay') {
                    this.showTempPayPage = value;
                } else if(type == 'renew') {
                    this.showTempRenewPage = value;
                } else {
                    this.showTempRegPage = value;
                }
            }
        },
        created() {
            this.getParameter();
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>